import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["design", "modal"];
  }

  static get values() {
    return { savedDesign: String };
  }

  connect() {
    $(this.designTarget).select2({ width: "100%" });
    $(this.modalTarget).on("hidden.bs.modal.giftPoolEdit", () => this.cancel());
  }

  disconnect() {
    $(this.designTarget).select2("destroy");
    $(this.modalTarget).off(".giftPoolEdit");
  }

  submit(event) {
    this.confirmed = false;
    if (this.designTarget.value === this.savedDesignValue) { return; }

    event.preventDefault();
    $(this.modalTarget).modal("show");
  }

  confirm(event) {
    event.preventDefault();
    this.confirmed = true;
    $(this.modalTarget).modal("hide");
    this.element.submit();
  }

  cancel() {
    if (this.confirmed) { return; }

    $.rails.enableFormElements($(this.element));
  }
}
